const apiBaseUrl = process.env.REACT_APP_BOOKING_API_BASE_URL;
const tenantSlug = process.env.REACT_APP_BOOKING_TENANT_SLUG;

function assertBookingApiConfig() {
    if (!apiBaseUrl || !tenantSlug) {
        throw new Error('Booking API non configurata.');
    }
}

function endpoint(path) {
    assertBookingApiConfig();
    return `${apiBaseUrl.replace(/\/$/, '')}/api/public/tenants/${tenantSlug}/${path}`;
}

async function postBookingJson(path, payload, headers = {}) {
    const response = await fetch(endpoint(path), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
        body: JSON.stringify(payload),
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data.error || 'Richiesta non riuscita.');
    }

    return data;
}

function getLocale() {
    return localStorage.getItem('lng') || 'it';
}

function bookingPayload(formData) {
    return {
        checkin_date: formData.checkin_date,
        checkin_time: formData.checkin_time,
        checkout_date: formData.checkout_date,
        checkout_time: formData.checkout_time,
        vehicles: formData.vehicles.map((vehicle) => ({
            vehicleType: vehicle.vehicleType,
            vehicleLength: vehicle.vehicleLength,
            services: vehicle.services || '',
        })),
        has_transfer: formData.has_transfer,
        transfer_type: formData.transfer_type,
        passengers_outbound: formData.passengers_outbound,
        dropoff_place: formData.dropoff_place,
        dropoff_place_detail: formData.dropoff_place_detail,
        embark_detail: formData.embark_detail,
        passengers_return: formData.passengers_return,
        pickup_place: formData.pickup_place,
        pickup_place_detail: formData.pickup_place_detail,
        disembark_detail: formData.disembark_detail,
        disembark_time: formData.disembark_time,
        train_arrival_time: formData.train_arrival_time,
        pickup_time: formData.pickup_time,
    };
}

function bookingCreatePayload(formData) {
    return {
        ...bookingPayload(formData),
        customer_name: formData.customer_name,
        customer_surname: formData.customer_surname,
        customer_email: formData.customer_email,
        customer_phone: formData.customer_phone,
        message: formData.message,
        personal_data: formData.personal_data,
        payment_terms: formData.payment_terms,
        locale: getLocale(),
        company: formData.company || '',
    };
}

export async function requestBookingQuote(formData) {
    const data = await postBookingJson('booking-quote', bookingPayload(formData));
    return data.quote;
}

export function createBookingIdempotencyKey() {
    if (typeof window.crypto?.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }

    return `booking_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
}

export async function createBooking(formData, idempotencyKey) {
    return postBookingJson('bookings', bookingCreatePayload(formData), {
        'Idempotency-Key': idempotencyKey,
    });
}
